module.exports = __webpack_public_path__ + "img/_logo-usps-eagle-only.f7be4b59.svg";